export var ModulePrefix;
(function (ModulePrefix) {
    ModulePrefix["TownPlanning"] = "TP";
    ModulePrefix["Gautrain"] = "GTIA";
    ModulePrefix["BuildingPlans"] = "BP";
    ModulePrefix["BuildingPlansInspectorate"] = "BPI";
    ModulePrefix["Wayleaves"] = "W";
    ModulePrefix["PropertyAndLease"] = "PL";
    ModulePrefix["Cemetery"] = "CM";
    ModulePrefix["PropertyValuation"] = "PV";
    ModulePrefix["Advertising"] = "A";
    ModulePrefix["EnvironmentalHealth"] = "EH";
    ModulePrefix["DemolitionManagement"] = "DM";
    ModulePrefix["ZoningCertificate"] = "ZC";
    ModulePrefix["TrainingModule"] = "TM";
    ModulePrefix["InformalTrade"] = "IT";
    ModulePrefix["RatesCertificate"] = "RC";
    ModulePrefix["BusinessLicence"] = "BL";
    ModulePrefix["ElectricalConnection"] = "EC";
    ModulePrefix["StreetNaming"] = "SN";
    ModulePrefix["Mondi"] = "MND";
})(ModulePrefix || (ModulePrefix = {}));
